import React, { Component } from 'react';
import JobsTable from '../jobs/jobs-table.jsx';
import moment from 'moment';
export default class Driver extends Component {
  constructor(props) {
    super(props);
    let url = "/api/v1/portal/jobs/driver/" +
        props.data.driver.id +
        (props.viewAllJobs ? "/all-jobs" : "");

    let driverEarningUrl = "/api/v1/portal/jobs/driver_earnings/" +
        props.data.driver.id +
        (props.viewAllJobs ? "/all-jobs" : "");    

    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || {
        driver: null
      },
      notes:props.data.driver.notes,
      isLoading: true,
      infiniteScroll: props.infiniteScroll || false,
      viewAllJobs: props.viewAllJobs || null,
      jobs: props.jobs || null,
      url: url || null,
      driverEarningUrl: driverEarningUrl || null,
      jobIds:[],
      driverDailyEarnings : props.driverDailyEarnings || '0.00',
      driverDailyEarningButtonColor : props.driverDailyEarningButtonColor,
      driverWeeklyEarnings : props.driverWeeklyEarnings || '0.00',
      driverWeeklyEarningButtonColor : props.driverWeeklyEarningButtonColor,
      isDriverDashboardPage: props.isDriverDashboardPage || false,
    };
    Echo.channel('driver-scheduled-list-update').listen('DriverScheduledListUpdate', (e) => {
      if(e.driverId){
        if(e.driverId == this.props.data.driver.id){
          this.getDriverJobs();
          $('#driver-table-list-'+e.driverId +' .late-driver-alert ').removeClass('late-driver-alert');
        }
      }else{
        if(this.state.jobs && this.state.jobs.length > 0){
          let Updateindex = this.state.jobs.findIndex(job => job.id == e.jobId);
          if(Updateindex != -1){
            this.state.jobs.splice(Updateindex, 1);
            this.setState({jobs:this.state.jobs});
          }
        }
      }
    });
    this.getDriverJobs = this.getDriverJobs.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data
      });
    }
  }
  getDriverJobs(){
    return fetch(
      this.state.url,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        }
      }
    ).then((responseText) => {
      let response = responseText.json();
      response.then((driverJson) => {
          this.setState({
          jobs: driverJson.data,
          driverDailyEarnings : driverJson.driverDailyEarnings,
          driverDailyEarningButtonColor : driverJson.driverDailyEarningButtonColor,
          driverWeeklyEarnings : driverJson.driverWeeklyEarnings,
          driverWeeklyEarningButtonColor : driverJson.driverWeeklyEarningButtonColor,
          isLoading: false
        });
        let jobIds = [];
        if (this.state.jobs) {
          this.state.jobs.map((job) => {
            jobIds.push(job.id);
          });
        }
        this.setState({jobIds:jobIds});

        if(this.state.isDriverDashboardPage){
          // this.props.handleDriverStatestics(overdueJobs,overdueJobsIn24hours,this.state.data.id);
          this.props.handleRerenderTrigger(this.state.jobs, this.state.data.id, this.state.data.driver);
        }
          
      });
    });
  }
  componentDidMount() {
    if (this.state.isLoading) {
      this.getDriverJobs();
    }
  }
  componentDidUpdate() {
    let pickupTime = ['?','anytime','am','asap','pm'];
    let scheduledPickupTime = '';
    let scheduledPickupDate = '';
    let msg = null;
    if(this.state.jobs && this.state.jobs.length > 0){
      let tempJob = this.state.jobs[0];
      
      if(pickupTime.indexOf(tempJob.scheduled_pickup_time) != -1){
        //console.log('this.state.jobs',pickupTime.indexOf(tempJob.scheduled_pickup_time) + '= '+tempJob.scheduled_pickup_time + '= '+moment().format("HHmm a"));
        scheduledPickupTime = '0805';
        scheduledPickupDate = tempJob.scheduled_pickup_year+'-'+tempJob.scheduled_pickup_month+'-'+tempJob.scheduled_pickup_day;
      }else{
        //console.log('else',tempJob.scheduled_pickup_time);
        scheduledPickupTime = tempJob.scheduled_pickup_time;
        scheduledPickupDate = tempJob.scheduled_pickup_year+'-'+tempJob.scheduled_pickup_month+'-'+tempJob.scheduled_pickup_day;
      }
      /* check if appraisal is not set yet */
      if(tempJob.appraisal_id == null){
        let currentDate = moment().format('YYYY-MM-DD'); 
        if( (moment(currentDate).isSame(scheduledPickupDate)) && (moment().format("HHmm") > scheduledPickupTime)){
          msg = '<div><b>'+this.state.data.full_name+':</b> '+"<a target='_blank' href='/jobs/view/"+tempJob.id+"'> #"+tempJob.id+"</a> ("+this.state.data.driver.contact_number+')</div>';
          $('#jobs-table-row-'+tempJob.id).addClass('late-driver-alert');
          this.props.saveLateJobIdsOFDriver(tempJob.id);
        }
      }
    }
    // this.props.handleLateDrivers(msg,this.state.data.id);
  }
  changeJobPrice(e) {
    let driverNotes = this.state.data.driver.notes;
    if (driverNotes === this.state.notes) {
      return null;
    }
    let changeJobPrice = confirm('change driver notes to:- '+ driverNotes + '?');
    if (changeJobPrice) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-driver-notes/"+this.state.data.driver.id,
        data: {
          api_token: window.api_token,
          driver_notes: driverNotes
        },
        cache: false,
        method: 'post',
      })
      .done(function() {
        // 
      }).
      catch(function(e) {
        alert(e);
      });
    }
    else {
      $("input[name=job_price]").val(e.target.value);
    }
  }
  enterPressed(event) {
    let code = event.keyCode || event.which;
    if (code === 13) { // [ Enter ]
      $(event.target).trigger('blur');
    }
  }
  handleDriverNotesChange(event){
    
    this.state.data.driver.notes =  event.target.value
    this.setState({data: this.state.data});
    console.log(this.state.data.driver.notes);
  }
  render() {
    let did = "driver-table-list-"+this.state.data.driver.id;
    let companyImages = [];
    if(this.state.data.company.short_name=='CND'||this.state.data.company.short_name=='cnd')
    {
      companyImages.push(<img key={"companiesLogoCND"+ this.state.data.driver.id} src="/images/companies/cnd.png" className="companiesLogoCND"/>);
    }
    if(this.state.data.company.short_name=='ACV'||this.state.data.company.short_name=='avc')
    {
      companyImages.push(<img key={"companiesLogoACV"+ this.state.data.driver.id} src="/images/companies/acv.png" className="companiesLogoACV"/>);
    }
    if(this.state.data.company.short_name=='BVL'||this.state.data.company.short_name=='bvl')
    {
      companyImages.push(<img key={"companiesLogoBVL"+ this.state.data.driver.id} src="/images/companies/bvl.png" className="companiesLogoBVL"/>);
    }
    if(this.state.data.company.short_name=='SCCD'||this.state.data.company.short_name=='sccd')
    {
      companyImages.push(<img key={"companiesLogoSCCD"+ this.state.data.driver.id} src="/images/companies/sccd.png" className="companiesLogoSCCD"/>);
    }
    if(this.state.data.company.short_name=='ACV-TRUCK'||this.state.data.company.short_name=='acv-truck')
    {
      companyImages.push(<img key={"companiesLogoACVTRUCK"+ this.state.data.driver.id} src="/images/companies/acv_truck.png" className="companiesLogoACVTRUCK"/>);
    }

    let schedulePanelColor = '';
    if(this.state.data.is_driver_one_job)
    {
      schedulePanelColor = 'schedule_panel_purple';
    }
    if(this.state.data.is_driver_new)
    {
      schedulePanelColor = 'schedule_panel_blue';
    }
    if(this.state.data.is_driver_sick)
    {
      schedulePanelColor = 'schedule_panel_green';
    }
    if(this.state.data.is_driver_do_not_pay)
    {
      schedulePanelColor = 'schedule_panel_red';
    }
    
    /* let did = "driver-table-list-"+this.state.data.driver.id; */
    let infiniteScroll = this.state.infiniteScroll;

    let lastJobOfDriver;
    let dashboardPanelColor = 'bg-pink';
    //you can change currentDay to simulate code for saturday and sunday!
    //i.e. moment("2023-10-13 00:00:00")
    const currentDay = moment();
    let fifthAndMoreDay = moment(currentDay).clone().add(4,'day');
    let forthDay = moment(currentDay).clone().add(3,'day');
    let dayAfterTommorow = moment(currentDay).clone().add(2,'day');
    let tommorow = moment(currentDay).clone().add(1,'day');
    let today = moment(currentDay).clone();
   
    //skip saturday and sunday for day hth day.
    while (fifthAndMoreDay.day() === 0 || fifthAndMoreDay.day() === 6) {
      fifthAndMoreDay = fifthAndMoreDay.add(2, "day");
    }
    //skip saturday and sunday for 4th day.
    while (forthDay.day() === 0 || forthDay.day() === 6) {
      forthDay = forthDay.add(2, "day");
    }
    //skip saturday and sunday for day after tommorow.
    while (dayAfterTommorow.day() === 0 || dayAfterTommorow.day() === 6) {
      dayAfterTommorow = dayAfterTommorow.add(2, "day");
    }
    //skip saturday and sunday for tommorow.
    while (tommorow.day() === 0 || tommorow.day() === 6) {
      tommorow = tommorow.add(2, "day");
    }

    if(this.state.isDriverDashboardPage && this.state.jobs){
      lastJobOfDriver = _.last(this.state.jobs);
      if(!lastJobOfDriver){
        // not job available.
        dashboardPanelColor = 'bg-primary';
      } else {
        const scheduled_dropoff_date = moment(lastJobOfDriver.scheduled_dropoff_date).format('Y-M-D');
        if(moment(scheduled_dropoff_date).isSameOrAfter(fifthAndMoreDay.format('Y-M-D'))){
          //day afer 96 hrs, yello color
          dashboardPanelColor = 'bg-yellow';
        }
        if(moment(scheduled_dropoff_date).isSame(forthDay.format('Y-M-D'))){
          //day afer 72 hrs, cyan color
          dashboardPanelColor = 'bg-cyan';
        }
        if(moment(scheduled_dropoff_date).isSame(dayAfterTommorow.format('Y-M-D'))){
          //day afer tommorow, green color
          dashboardPanelColor = 'bg-success';
        }
        if(moment(scheduled_dropoff_date).isSame(tommorow.format('Y-M-D'))){
          //next day, orange color
          dashboardPanelColor = 'bg-orange';
        }
        if(moment(scheduled_dropoff_date).isSame(today.format('Y-M-D'))){
          //same day, red color.
          dashboardPanelColor = 'bg-danger';
        }
      }
      if(this.state.data.is_driver_sick){
        //driver is not active or sick
        dashboardPanelColor += ' text-decoration-line-through';
      }

    }

    return(
    <div className={"driver-table filter-" + (this.state.data.company.short_name).toLowerCase()} id={did} >
      {
        this.state.isLoading ?
        <div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div> :

          ((  this.state.data &&
              this.state.data.driver &&
              this.state.data.driver.contact_number &&
              !this.state.isDriverDashboardPage
            ) ?

              <div className="driver-container">
                <div className={(this.state.data.is_driver_sick) ? 'driver-main-info is-driver-sick' : 'driver-main-info'}>
                  <div className="row">
                    {/* <div className="col-md-1"> */}
                      {/* <img
                        src={"/user-images/" + this.state.data.id}
                        className="drivers-table-main-info-user-image"
                      /> */}
                    {/* </div> */}
                    <div className="col-md-3">
                      <DriverProfile data={this.state.data} />
                      {companyImages}
                      <a
                        href={"/drivers/view/" + this.state.data.id +
                        "/all-jobs"}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="fa fa-car-side"></i> All Jobs
                      </a>
                      {/* Driver Daily Earning */}
                      {(this.state.driverDailyEarnings) ?
                      <button type="button"
                        className={this.state.driverDailyEarningButtonColor}
                        data-toggle="tooltip" data-placement="right" data-original-title={this.state.driverDailyEarnings}
                      >
                        {this.state.driverDailyEarnings}
                      </button>
                      : ''} 
                      {/* Driver Weekly Earning */}
                      {(this.state.driverWeeklyEarnings) ?
                      <button type="button"
                        className={this.state.driverWeeklyEarningButtonColor}
                        data-toggle="tooltip" data-placement="right" data-original-title={this.state.driverWeeklyEarnings}
                      >
                        {this.state.driverWeeklyEarnings}
                      </button>
                      : ''} 
                    </div>
                    <div className="col-md-2 filter-date-section" style={{display: "inherit"}}>
                        {/* <textarea className="form-control form-control-lg"
                          name="driver_notes"
                          id="driver_notes"
                          placeholder="Add Notes"
                          defaultValue={this.state.data.driver.notes}
                          onChange={(e)=>this.handleDriverNotesChange(e)}>
                        </textarea> */}
                        <input type="text" className="jobs-table-editable form-control form-control-lg driver-notes-textbox"
                          value={this.state.data.driver.notes || ''}
                          placeholder="- Add Notes - "
                          onChange={(e)=>this.handleDriverNotesChange(e)}
                          name="notes" />&nbsp;&nbsp;
                          <a title="update driver notes" 
                             onClick={this.changeJobPrice.bind(this)}>
                               <i className="fa fa-lg fa-sync"></i>
                          </a>
                    </div>
                    <div className="col-md-3">
                      <i className="fa fa-phone"></i> {
                      this.state.data.driver.contact_number}
                      <i className="fa fa-envelope ml-3"></i>&nbsp; {
                        this.state.data.email}
                    </div>
                    {/* <div className="col-md-2">
                      <strong>Trade Plate:</strong>&nbsp;
                      <i className="fa fa-phone"></i> {
                      this.state.data.driver.contact_number}
                    </div>
                    <div className="col-md-2">
                        <i className="fa fa-envelope"></i>&nbsp; {
                        this.state.data.email}
                      </div> */}
                      { (this.state.data.driver.home_address) ? 
                      <div className="col-md-3">
                        <i className="fa fa-home"></i> {
                        this.state.data.driver.home_address.town_city} {
                        this.state.data.driver.home_address.county_area}&nbsp;&nbsp; | &nbsp;&nbsp;
                        <strong className="pFixed">Active/Working:&nbsp;&nbsp;
                          <button className="btn btn-primary buttonActiveWorking">
                            <b>{(this.state.data.driver.active_status) ? 'YES' : 'NO'}</b>
                          </button>
                        </strong>
                      </div>
                      : ''
                      }
                  </div>
                </div>
                <JobsTable
                  url={this.state.url}
                  jobs={this.state.jobs}
                  noCategoryLabels={true}
                  message_if_none='No Jobs found. Add one to see it here.'
                  driverScreen={(this.state.url.search('all-jobs') > -1) ? false : true}
                  infiniteScroll={this.state.infiniteScroll}
                  jobIds={this.state.jobIds}
                />
              </div>
              : ((this.state.data &&
                this.state.data.driver &&
                this.state.data.driver.contact_number &&
                this.state.isDriverDashboardPage
                ) ?
                    
              <div className="driver-container mb-0">
                 
                  <div className={"driver-main-info "+dashboardPanelColor+""}>
                  <div className="row">
                    <div className="col-md-3">
                      <p>{this.state.data.first_name} {this.state.data.last_name} &nbsp;&nbsp; </p>
                    </div>
                    <div className="col-md-3" title= {_.get(lastJobOfDriver ,'id')}>
                       {/* <p> {_.get(lastJobOfDriver,'drop_day')} {this.state.data.driver.cold_start_status} </p> */}
                       {(_.get(lastJobOfDriver ,'scheduled_dropoff_date')) ? 
                        <p>{moment(_.get(lastJobOfDriver ,'scheduled_dropoff_date')).format('DD-MM-YYYY, hh:mm:ss') ?? null}</p>
                       : null}
                    </div>
                    <div className="col-md-3">
                      <p>{_.get(lastJobOfDriver ,'dropoff_address.town_city')}</p>
                    </div>
                    { (this.state.data.driver.home_address) ? 
                      <div className="col-md-3">
                        <p><i className="fa fa-home"></i> {this.state.data.driver.home_address.town_city} </p>
                      </div>
                      : ''
                      }
                    </div>
                </div>
              </div>
              : null)
          )
        }
      </div>
    );
  }
}

class DriverProfile extends Component {

  isLightColor(hex) {
    const rgb = parseInt(hex.substring(1), 16); // Convert hex to RGB
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff;
    // Use a simple formula to determine if the color is light
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 155; // Adjust threshold as needed
  };
  render() {
    const { data } = this.props;
    let colors = '';

    if (data.driver.color_tag != null) {
      if (this.isLightColor(data.driver.color_tag)) {
        colors = '#000000';
      } else {
        colors = '#ffffff';
      }
    }

    return (
      <div style={{ display: 'inline-block', backgroundColor: data.driver.color_tag, color: colors }}>
        <img
          src={"/user-images/" + data.id}
          className="drivers-table-main-info-user-image"
        />&nbsp;&nbsp;&nbsp;
        {/* <strong>Driver Name:</strong>  */}
        {data.first_name} {data.last_name}&nbsp;&nbsp;
      </div>
    )
  }
}